/**
 * Labstep
 */

import {
  ORGANIZATIONS,
  type Organization,
} from 'labstep-web/constants/saml';

export class SAMLService {
  public static getOneBySamlIdentifier = (
    samlIdentifier: string,
  ): Organization | null => {
    return (
      ORGANIZATIONS.find(
        (organization) => organization.identifier === samlIdentifier,
      ) || null
    );
  };
}
